import styled, { css } from 'styled-components';

export const Base = styled.div`
	display: flex;
	align-items: center;
	height: 100%;
	min-width: 0;
	width: 100%;
`;

export const TabBar = styled.div`
	display: flex;
	align-items: center;
	gap: 0;
	height: 100%;
	min-width: 0;
	overflow: hidden;
	flex: 0 1 auto;
`;

export const TabCloseButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 18px;
	height: 18px;
	border-radius: 6px;
	border: none;
	background: ${({ theme }) => theme.gray[100]};
	color: ${({ theme }) => theme.gray[1000]};
	opacity: 0;
	pointer-events: none;
	transition: opacity 0.15s ease, background-color 0.15s ease;
	padding: 0;
	position: absolute;
	right: 4px;
	top: 50%;
	transform: translateY(-50%);
	z-index: 1;
	user-select: none;

	&:hover {
		background: ${({ theme }) => theme.gray[400]};
	}
`;

export const TabCloseBacking = styled.div`
	position: absolute;
	right: 4px;
	top: 50%;
	transform: translateY(-50%);
	width: 20px;
	height: 20px;
	border-radius: 0px;
	background: ${({ theme }) => theme.gray[100]};
	z-index: 0;
	opacity: 0;
	transition: opacity 0.15s ease;
`;

export const AddTabButtonWrapper = styled.div`
	flex-shrink: 0;
`;

export const TabIcon = styled.span`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
`;

export const Tab = styled.button<{
	$active?: boolean;
	$isDragging?: boolean;
}>`
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 8px 12px;
	padding-right: 24px;
	height: 48px;
	border: none;
	background: ${({ $active, theme }) => ($active ? theme.gray[100] : 'transparent')};
	color: ${({ $active, theme }) => ($active ? theme.gray[1000] : theme.gray[700])};
	font-family: 'Inter', sans-serif;
	font-size: 14px;
	font-weight: 500;
	transition: color 0.2s ease-in-out, background-color 0.2s ease-in-out, opacity 0.2s ease-in-out;
	user-select: none;
	outline: none;
	position: relative;
	white-space: nowrap;
	flex: 0 1 auto;
	min-width: 48px;
	max-width: 240px;
	overflow: hidden;
	opacity: ${({ $isDragging }) => ($isDragging ? 0.4 : 1)};

	${({ $active }) =>
		$active &&
		css`
			${TabCloseButton} {
				opacity: 1;
				pointer-events: auto;
			}
			${TabCloseBacking} {
				opacity: 1;
			}
		`}

	&:hover {
		${TabCloseButton} {
			opacity: 1;
			pointer-events: auto;
		}

		${TabCloseBacking} {
			opacity: 1;
		}

		${({ $active, theme }) =>
			!$active
				? `
			background-color: ${theme.gray[100]};
			color: ${theme.gray[1000]};
		`
				: ''}
	}
`;

export const HomeTab = styled(Tab)`
	padding-left: 14px;
	min-width: 42px;
	width: 42px;
`;

export const TabLabel = styled.span`
	white-space: nowrap;
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	flex: 1;
`;
